import { ChangeDetectionStrategy, Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { UnallocatedUserId } from '@jms/model';
import { LetterAvatar } from '../utilities';


@Component({
    selector: 'profile',
    styleUrls: ['profile.component.less'],
    template: `
    <div [ngClass]="{'user-image': true, 'has-status-icon': !!statusIcon}" >

        <ng-container *ngIf="useIcon; then iconTemplate; else imageTemplate"></ng-container>
        <ng-template #iconTemplate>
            <div class="icon" ><i class="fa" [ngStyle]="faStyle" [ngClass]="useIcon"></i></div>
        </ng-template>
        <ng-template #imageTemplate>
            <img [ngStyle]="faStyle" [src]="generateUserImage() | safeUrl" *ngIf="true" />
        </ng-template>
        
        <i [ngClass]="[statusIcon, 'status-icon']" class="status-icon" *ngIf="statusIcon"></i>
      <!--img [src]="getUrlProfile() | safeHtml" (error)="profileError()" *ngIf="!haveNoProfileUrl" /-->

    </div>
  `,
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProfileComponent implements OnChanges {
    public haveNoProfileUrl: boolean;
    public noUserImageUrl: string;

    @Input() userId: string;
    @Input() size = 30;
    @Input() userImageUrl: string;
    @Input() apiUrl: string;
    @Input() statusIcon: string;

    private _userName: string;

    public unallocatedUserId = UnallocatedUserId;
    public useIcon: string = null;

    public get userName(): string {
        return this._userName;
    }

    public faStyle;

    @Input()
    public set userName(value: string) {
        this._userName = value;

        if (value === UnallocatedUserId) {
            this.useIcon = 'fa-user';
            return;
        } else {
            this.useIcon = null;
        }

        this.generateUserImage();
    }

    getUrlProfile() {
        if (this.userImageUrl) return this.userImageUrl;

        if (!this.userId || !this.apiUrl) {
            this.haveNoProfileUrl = true;
            return '#';
        }
        return `${this.apiUrl}/users/profileimage/${this.userId}`;
    }

    profileError() {
        this.haveNoProfileUrl = true;
    }

    public ngOnChanges(): void {

        this.haveNoProfileUrl = false;

        if (this.size && !this.useIcon)
            this.generateUserImage();

        this.faStyle = {
            width: `${this.size}px`,
            height: `${this.size}px`,
            'line-height': `${this.size}px`
        };

    }

    public generateUserImage() {

        const username = this.userName?.replace(/[^a-zA-Z]/g, '');

        return LetterAvatar.generateSvgDataUri(
            username,
            this.size
        );
        // this.noUserImageUrl = LetterAvatar.generate(
        //   DomReferences.nativeWindow,
        //   DomReferences.nativeDocument,
        //   this.userName,
        //   this.size
        // );
    }

}
